import { NoteMark } from './annotatedNotitieTypes';

type MarkRange = Pick<NoteMark, 'start' | 'end'>;

const sortRanges = <T extends MarkRange>(ranges: T[]): T[] =>
  [...ranges].sort((a, b) => a.start - b.start || a.end - b.end);

export const mergeRanges = <T extends MarkRange>(ranges: T[]): Array<{ start: number; end: number }> => {
  const sortedRanges = sortRanges(ranges);
  const mergedRanges: Array<{ start: number; end: number }> = [];

  for (const range of sortedRanges) {
    const previousRange = mergedRanges.at(-1);

    if (!previousRange || previousRange.end < range.start) {
      mergedRanges.push({ start: range.start, end: range.end });
      continue;
    }

    previousRange.end = Math.max(previousRange.end, range.end);
  }

  return mergedRanges;
};

export const isPointCovered = (ranges: MarkRange[], point: number): boolean =>
  ranges.some((range) => range.start < point && range.end >= point);

export const isRangeCovered = (ranges: MarkRange[], start: number, end: number): boolean => {
  if (start >= end) return false;

  const mergedRanges = mergeRanges(ranges.filter((range) => range.start < end && range.end > start));
  let coveredUntil = start;

  for (const range of mergedRanges) {
    if (range.end <= coveredUntil) continue;
    if (range.start > coveredUntil) return false;
    coveredUntil = range.end;
    if (coveredUntil >= end) return true;
  }

  return false;
};
